import { render, staticRenderFns } from "./cambioCedula.vue?vue&type=template&id=3ffb9996"
import script from "./cambioCedula.vue?vue&type=script&lang=js"
export * from "./cambioCedula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports